module.exports = __webpack_public_path__ + "static/media/1010265.fcff0f3a.jpg";